import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import {UploadsSortOrder} from '@Panels/user-media-panel/user-media-panel.types';
import {getStoredUploadsSortOrder, isAlphabeticalUploadsSortOrder} from '@Panels/user-media-panel/uploads-sort-order.library';

interface StateProps {
  collection: string;
  isFbPanelOpen: boolean;
  isForDesignUpload: boolean;
  unlinkedMedia: GridItemStorage[];
  sortOrder: UploadsSortOrder;
  /** The last non-alphabetical choice, which the items grid keeps following on tabs whose items have no names. */
  lastNonAlphabeticalSortOrder: UploadsSortOrder;
}

const storedSortOrder = getStoredUploadsSortOrder();

const initialState: StateProps = {
  collection: '',
  isFbPanelOpen: false,
  isForDesignUpload: false,
  unlinkedMedia: [],
  sortOrder: storedSortOrder,
  lastNonAlphabeticalSortOrder: isAlphabeticalUploadsSortOrder(storedSortOrder) ? UploadsSortOrder.NEWEST_FIRST : storedSortOrder,
};

const uploadsSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    updateCurrentCollection: (state, action: PayloadAction<string>) => {
      state.collection = action.payload;
    },
    toggleIsFbPanelOpenState: (state, action: PayloadAction<boolean>) => {
      state.isFbPanelOpen = action.payload;
    },
    updateIsForDesignUpload: (state, action: PayloadAction<boolean>) => {
      state.isForDesignUpload = action.payload;
    },
    updateUnlinkedMediaState: (state, action: PayloadAction<GridItemStorage[]>) => {
      state.unlinkedMedia = [...state.unlinkedMedia, ...action.payload];
    },
    updateUploadsSortOrder: (state, action: PayloadAction<UploadsSortOrder>) => {
      state.sortOrder = action.payload;
      if (!isAlphabeticalUploadsSortOrder(action.payload)) {
        state.lastNonAlphabeticalSortOrder = action.payload;
      }
    },
  },
});

export const {updateCurrentCollection, toggleIsFbPanelOpenState, updateUnlinkedMediaState, updateIsForDesignUpload, updateUploadsSortOrder} = uploadsSlice.actions;
export const uploadsReducer = uploadsSlice.reducer;
